import { AbstractLayerSettingsState } from '../toolbars/layer-settings/abstract-layer-settings-state';
import { ObjectWith, RGBA } from '../types/misc';

// make sure numbers match with the shader point color switch
export enum PointColorMode {
  Intensity = 0,
  Sensor,
  InsideFocusedCuboid,
  Height,
}

export interface GroundingConfiguration {
  searchRadius: number;
  useAllPoints: boolean;
}

export const defaultShapeOpacity = 25;
export const defaultPointSize = 2.5;
export const defaultIntensityRange = { min: 0, max: 1 };
export const defaultPointColorMode: PointColorMode = PointColorMode.Intensity;
export const defaultGroundingConfiguration: GroundingConfiguration = {
  searchRadius: 1,
  useAllPoints: false,
};
export const defaultHighlightedSensor = -1;
export const defaultHeightRange = { min: 0, max: 10 };

export class LayerSettingsState3D extends AbstractLayerSettingsState {
  groundingConfiguration = defaultGroundingConfiguration;
  highlightedSensor = defaultHighlightedSensor;
  intensityRange = defaultIntensityRange;
  pointSize = defaultPointSize;
  pointColorMode = defaultPointColorMode;
  heightRange = defaultHeightRange;
  shapeIndexesToDebug: number[] = [];

  constructor(public pointAppearanceBySensor: ObjectWith<RGBA>) {
    super(defaultShapeOpacity);
  }
}
